// import type { CSSProperties } from 'react'
import { createTypography } from '@mildang/mui';
import { token } from '@mildang/styled-system/tokens';
import type { Palette } from '@mildang/mui';

const caseAllInitial = {
  textTransform: 'initial',
};

const generateTypo = ({
  palette,
  isMildangPTOnly = false,
}: {
  palette: Palette;
  isMildangPTOnly: boolean;
}) => {
  const {
    fontFamily = isMildangPTOnly ? token('fonts.mildangPretendard') : token('fonts.pretendard'),
    fontSize = 14, // px
    htmlFontSize = 16,
    // fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell Material-UI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    // Apply the CSS properties to all the variants.
    // allVariants,
    // pxToRem: pxToRem2,
  } = {};

  const coef = fontSize / 14;
  const pxToRem = (size: number) => `${(size / htmlFontSize) * coef}rem`;

  const buildVariant = (
    // fontWeight: CSSProperties['fontWeight'],
    fontWeight: number,
    size: number,
    lineHeightPx: number,
    letterSpacing: number,
    casing?: any,
  ) => ({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Convert PX to EM
    lineHeight: lineHeightPx / size,
    letterSpacing: `${letterSpacing}em`,
    ...casing,
    // ...allVariants,
  });

  return createTypography(palette, {
    d1: buildVariant(600, 48, 68, -0.004),
    h1: buildVariant(600, 40, 56, -0.004),
    h2: buildVariant(700, 32, 44, 0),
    h3: buildVariant(700, 28, 40, 0),
    h4: buildVariant(700, 24, 36, 0),
    h5: buildVariant(700, 22, 32, 0),
    h6: buildVariant(700, 20, 30, 0),
    subtitle1_B: buildVariant(700, 18, 28, 0),
    subtitle1_M: buildVariant(500, 18, 28, 0),
    subtitle2_B: buildVariant(700, 16, 26, 0),
    subtitle2_M: buildVariant(500, 16, 26, 0),
    subtitle3_B: buildVariant(700, 15, 24, 0),
    subtitle3_M: buildVariant(500, 15, 24, 0),
    subtitle4_B: buildVariant(700, 14, 22, 0),
    subtitle4_M: buildVariant(500, 14, 22, 0),
    body1: buildVariant(fontWeightRegular, 18, 30, 0),
    body1_B: buildVariant(fontWeightBold, 18, 30, 0),
    body2: buildVariant(fontWeightRegular, 16, 28, 0),
    body3: buildVariant(fontWeightRegular, 15, 26, 0),
    body4: buildVariant(fontWeightRegular, 14, 24, 0),
    body4_B: buildVariant(fontWeightBold, 14, 24, 0),
    chat_body1_R: buildVariant(fontWeightRegular, 15, 20, 0),
    buttonXL: buildVariant(fontWeightMedium, 18, 28, 0, caseAllInitial),
    buttonL: buildVariant(fontWeightMedium, 15, 26, 0, caseAllInitial),
    buttonM: buildVariant(fontWeightMedium, 14, 24, 0, caseAllInitial),
    buttonS: buildVariant(fontWeightMedium, 13, 20, 0, caseAllInitial),
    caption1_R: buildVariant(400, 13, 22, 0),
    caption1_M: buildVariant(500, 13, 22, 0),
    caption2_R: buildVariant(400, 12, 20, 0),
    caption2_M: buildVariant(500, 12, 20, 0),
    caption3_R: buildVariant(400, 10, 18, 0),
    caption3_M: buildVariant(500, 10, 18, 0),
    chat_caption1_R: buildVariant(400, 12, 16, 0),
    fontFamily,
  });
};

export default generateTypo;
